/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
/* eslint-disable jsx-a11y/anchor-is-valid  */
import React, { useEffect, useState, useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { NavLink, generatePath, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ConfigContext from 'app/context/config';
import { onClickBehaviorMobile } from 'app/utils';
import { useConfig, useRouter } from 'app/hooks';
import { Modal } from 'app/components';
import useModal from 'app/hooks/useModal';
import { IsMobile, NavListMobile, NavList, NavListItem, SubList, SubListItem } from './styles';
import MobileImg from '../../../assets/images/mobileNav.png';
import LeftArrowIcon from '../../../assets/images/leftArrowIcon2.png';
import CloseImg from '../../../assets/images/close.png';
import { linkTo, withUTM } from 'utils';
import { generateUniqueId } from 'utils';

const propTypes = {
  cinemas: PropTypes.arrayOf(PropTypes.object).isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  savedLocation: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
};

const MobileNav = ({ cinemas, locations, savedLocation, isLoggedIn, pathname }) => {
  const [t, i18n] = useTranslation();
  const { routes, showingOptions } = useContext(ConfigContext);
  // eslint-disable-next-line no-unused-vars
  const [cinemasToShow, setCinemas] = useState([]);
  const [isOpen, setIsOpen] = useState(false);


  const {
    // giftCardShop,
    streamingUrl,
    giftCardShopEN,
    giftCardShopDE,
    vodNotLoggedInUrlEN,
    vodNotLoggedInUrlDE
  } = useConfig();
  const history = useHistory();
  const refreshToken = localStorage.getItem('refreshToken');
  const streamingUrlSet = `${streamingUrl}?refresh_token=${refreshToken}`;
  // eslint-disable-next-line no-unused-vars
  const [streamingFunction, showStreamingFunction, hideStreamingFunction] = useModal('streamingFunction');

  const location = useLocation();
  const countryCode = process.env.REACT_APP_COUNTRY;
  // console.log("location",location.pathname);
  const clubList = useMemo(
    () => [
      {
        id: 1,
        label: 'bonusCard',
        name: t('common.bonus_card'),
        route: routes.bonusCardInfo.pattern
      },
      {
        id: 2,
        label: 'familyFilmclub',
        name: t('common.family_film_club'),
        route: routes.familyFilmClub.pattern
      },
      {
        id: 3,
        label: 'competitions',
        name: t('common.competitions'),
        route: routes.competitionInfo.pattern
      }
    ],
    [t]
  );

  const giftcardList = useMemo(
    () => [
      {
        id: 1,
        label: 'giftcardShop',
        name: t('common.giftcard_shop'),
        route: null
      },
      {
        id: 2,
        label: 'giftcardInfo',
        name: t('common.giftcard_info'),
        route: routes.giftCardInfo.pattern
      }
    ],
    [t]
  );

  const data = sessionStorage.getItem("movieCinemaId");

  useEffect(() => {
    if (savedLocation === 'all') {
      setCinemas(cinemas);
    } else {
      /* eslint-disable no-param-reassign */
      const items = locations.reduce((res, l) => {
        if (l.id.toString() === savedLocation) {
          res = l.items;
        }

        return res;
      }, []);
      /* eslint-enable no-param-reassign */

      if (items.length) {
        setCinemas(cinemas.filter(c => items.some(i => i.toString() === c.id)));
      }
    }
  }, [locations, cinemas, savedLocation]);

  const OpenMenu = () => {
    setIsOpen(!isOpen);
  };

  const goBackLink = () => {
    const cinemaId = location.pathname?.split('/')[3]?.split('-')[0];
    const currentStep = location.pathname?.split('/')[4];
    const dataConcessionsale = cinemas?.find(item => item?.id === cinemaId);

    if (dataConcessionsale?.concessionsale) {
      const getNextStep = (step) => {
        switch (step) {
          case 'tickets':
            return 'goBack';
          case 'seats':
            return 'tickets';
          case 'snacks':
            return 'seats';
          case 'checkout':
            return 'snacks';
          default:
            return null;
        }
      };

      const nextStep = getNextStep(currentStep);

      if (nextStep === 'goBack') {
        history.goBack();
      } else {
        history.replace(withUTM({ pathname: `/purchase/wizard/${data}/${nextStep}` }));
      }
    }
    else {
      if (currentStep === 'tickets') {
        history.goBack();
      } else if (currentStep === 'seats') {
        history.replace(withUTM({ pathname: `/purchase/wizard/${data}/tickets` }));
      } else if (currentStep === 'checkout') {
        history.replace(withUTM({ pathname: `/purchase/wizard/${data}/seats` }));
      }
    }
  };


  const findArrayElementByTitle = (arrayList, pathname) => {
    let result = '-';

    arrayList.find(element => {
      if (element.route === pathname) {
        if (Object.keys(element).length > 0) {
          result = '_hover';
        } else {
          result = '-';
        }
      }

      return null;
    });

    return result;
  };

  useEffect(() => {
    window.onclick = function (event) {
      if (document.getElementById('mobileNavigation').contains(event.target)) {
        // Clicked in box
      } else {
        // Clicked outside the box
        setIsOpen(false);
      }
    }
  }, [])

  return (
    <>
      <IsMobile id="mobileNavigation">
        {
          isOpen ? (
            <img src={CloseImg} className="mobileMenuClose" id='image' onClick={OpenMenu} alt="menu-logo" />
          ) : (
            location.pathname?.split('/')[4] === "tickets" || location.pathname?.split('/')[4] === "snacks" || location.pathname?.split('/')[4] === "seats" || location.pathname?.split('/')[4] === "checkout" ?
              <img src={LeftArrowIcon} className="mobileMenu LeftArrowIcon" id='image' onClick={goBackLink} alt="menu-logo" />
              : <img src={MobileImg} className="mobileMenu" id='image' onClick={OpenMenu} alt="menu-logo" />
          )
        }
        {
          isOpen && (
            <div>
              <NavListMobile>
                <Modal
                  isOpen={streamingFunction}
                  close={hideStreamingFunction}
                  title="Streaming"
                >
                  <h3>{t('common.streaming_condition')}</h3>
                </Modal>
                <NavList>
                  {showingOptions?.member && (
                    <NavListItem
                      {...onClickBehaviorMobile}
                      chevron
                      isLoggedIn={isLoggedIn}
                      className={findArrayElementByTitle(clubList, pathname)}
                      id={`header-mobile-nav-navListItem-${generateUniqueId()}`}
                    >
                      <span className="_with-chevron chevron_arrow">{t('common.club')}</span>
                      <SubList>
                        {clubList.map(
                          ({ id, label, name, route }) =>
                            showingOptions?.club?.[label] && (
                              <SubListItem key={id} activeClassName="_active" id={`header-mobile-nav-subListItem-${generateUniqueId()}`}>
                                <NavLink
                                  className="l-sublist__link"
                                  to={withUTM({
                                    pathname: generatePath(route)
                                  })}
                                  activeClassName="_active"
                                  exact
                                  onClick={OpenMenu}
                                  id={`header-mobile-nav-link-${generateUniqueId()}`}
                                >
                                  {name.toLowerCase()}
                                </NavLink>
                              </SubListItem>
                            )
                        )}
                      </SubList>
                    </NavListItem>
                  )}
                  {showingOptions?.giftcards && (
                    <NavListItem
                      {...onClickBehaviorMobile}
                      chevron
                      isLoggedIn={isLoggedIn}
                      className={findArrayElementByTitle(giftcardList, pathname)}
                      id={`header-mobile-nav-navListItem-${generateUniqueId()}`}
                    >
                      <span className="_with-chevron chevron_arrow">{t('common.giftcards')}</span>
                      <SubList>
                        {giftcardList.map(
                          ({ id, label, name, route }) =>
                            showingOptions?.giftCards?.[label] && (
                              <SubListItem key={id} activeClassName="_active" id={`header-mobile-nav-subListItem-${generateUniqueId()}`}>
                                {name === t('common.giftcard_shop') ? (
                                  <a
                                    href={i18n.language === 'en' || i18n.language === 'en-US' ? giftCardShopEN : giftCardShopDE}
                                    className="l-sublist__link"
                                    activeClassName="_active"
                                    exact
                                    onClick={OpenMenu}
                                    id={`header-mobile-nav-link-${generateUniqueId()}`}
                                  >
                                    {' '}
                                    {name.toLowerCase()}
                                  </a>
                                ) : (
                                  <NavLink
                                    className="l-sublist__link"
                                    to={withUTM({
                                      pathname: generatePath(route)
                                    })}
                                    activeClassName="_active"
                                    exact
                                    onClick={OpenMenu}
                                    id={`header-mobile-nav-link-${generateUniqueId()}`}
                                  >
                                    {name.toLowerCase()}
                                  </NavLink>
                                )}
                              </SubListItem>
                            )
                        )}
                      </SubList>
                    </NavListItem>
                  )}

                  {showingOptions?.cinemaRent && (
                    <NavListItem isLoggedIn={isLoggedIn} id={`header-mobile-nav-navListItem-${generateUniqueId()}`}>
                      <NavLink
                        to={linkTo(routes.cinemaRent.pattern)}
                        activeClassName="_active"
                        exact
                        onClick={OpenMenu}
                        id={`header-mobile-nav-link-${generateUniqueId()}`}
                      >
                        {t('common.cinema_rent')}
                      </NavLink>
                    </NavListItem>
                  )}
                  {countryCode === 'aut' && (
                    <NavListItem isLoggedIn={isLoggedIn}>
                      <NavLink
                        to={{
                          pathname: routes.opera.pattern
                        }}
                        activeClassName="_active"
                        exact
                      >
                        {t('common.opera')}
                      </NavLink>
                    </NavListItem>
                  )}
                  {showingOptions?.streaming && (
                    <NavListItem isLoggedIn={isLoggedIn} id={`header-mobile-nav-navListItem-${generateUniqueId()}`}>
                      {isLoggedIn ?
                        <a
                          activeClassName="_active"
                          exact
                          href={streamingUrlSet}
                          id={`header-mobile-nav-link-${generateUniqueId()}`}
                        >
                          {t('common.streaming')}
                        </a>
                        : <a
                          activeClassName="_active"
                          exact
                          href={18n.language === 'en' ? vodNotLoggedInUrlEN : vodNotLoggedInUrlDE}
                          id={`header-mobile-nav-link-${generateUniqueId()}`}
                        >
                          {t('common.streaming')}
                        </a>
                      }
                    </NavListItem>
                  )}
                  {showingOptions?.cinemaRent && (
                    <NavListItem isLoggedIn={isLoggedIn}>
                      <NavLink
                        to={linkTo(routes.faq.pattern)}
                        activeClassName="_active"
                        exact
                        onClick={OpenMenu}
                      >
                        {t('footer.contact_us')}
                      </NavLink>
                    </NavListItem>
                  )}
                </NavList>
              </NavListMobile>
            </div>
          )
        }
      </IsMobile>
    </>
  );
};

MobileNav.propTypes = propTypes;
export default MobileNav;
